import { NextPage } from 'next';
import HomePage from '@sy/app-client/src/ssrAdapter/pages/HomePage';

import MarketingTemplate from '~/components/templates/MarketingTemplate';
import buildMetatadata, { getCanonicalUrl } from '~/utils/buildMetadata';
import { getMarketingNavigation } from '~/utils/getNavigation';
import useIHeartTracking from '@sy/app-client/src/ssrAdapter/components/useIHeartTracking';
import { buildGetServerSideProps } from '../getServerSideProps';
import type { CommonContext, InferProps } from '../getServerSideProps';

const Home: NextPage<HomeProps> = ({ featureFlags, navigation, user }) => {
	useIHeartTracking({
		action: 'lead',
	});
	const isLogoExperimentVariant =
		featureFlags.orion.logoExperimentVariant === 'treatment2';
	return (
		<MarketingTemplate
			featureFlags={featureFlags}
			navigation={navigation}
			user={user}
			logoVersion={featureFlags.orion.logoExperimentVariant}
			isLogoExperimentVariant={isLogoExperimentVariant}
		>
			<HomePage isLogoExperimentVariant={isLogoExperimentVariant} />
		</MarketingTemplate>
	);
};

const customServerSideProps = async (context: CommonContext) => {
	const { locale, featureFlags, query, requestUrl } = context;
	const { origin, pathname } = requestUrl;

	const canonicalUrl = getCanonicalUrl(origin, pathname, locale);

	return {
		props: {
			metadata: buildMetatadata({
				canonical: canonicalUrl,
				host: requestUrl.host,
				pathname,
			}),
			navigation: await getMarketingNavigation({ featureFlags, locale, query }),
		},
	};
};

export const getServerSideProps = buildGetServerSideProps({
	customServerSideProps,
	translationNamespaces: [
		'common',
		'landingMainPage',
		'landing',
		'auth',
		'pricing',
	],
	redirect: {
		anonOnly: true,
		redirectTo: '/broadcasts',
		propagateQueryParameters: true,
	},
});

export type HomeProps = InferProps<typeof getServerSideProps>;

export default Home;
